const utils = {

    ecuHistoryFixer: (rows) => {
        var temp = rows.reverse()
        var first_id = 0
        var prev_calib_id = 0
        temp.map(row => {
            if (row._TBL === "calib") {
                //console.log(row.calib_id)
                if (first_id === 0) {
                    first_id = row.calib_id
                }
                row.first_calib_id = first_id
                if (prev_calib_id !== row.calib_id) {
                    row.prev_calib_id = prev_calib_id
                    prev_calib_id = row.calib_id
                } else {
                    row.prev_calib_id = 0
                }
            }
        })
        //console.log(temp)
        return temp.reverse()
    },
      
    decimalToHex: (d, padding = 2) => {
        var hex = Number(d).toString(16);
        while (hex.length < padding) {
            hex = "0" + hex;
        }
        return hex;
    },

    byteArrayToHex: (b) => {
        var str = "" 
        for (var byte_value of b) {
            str += utils.decimalToHex(byte_value) + " "
        }
        return str
    },

    sleep: (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    },

    hexStringToByteArray: (hexString) => {
        if (hexString.length % 2 !== 0) {
            return undefined
        } /* w w w.  jav  a2 s .  c o  m*/
        var numBytes = hexString.length / 2;
        var byteArray = new Uint8Array(numBytes);
        for (var i = 0; i < numBytes; i++) {
            byteArray[i] = parseInt(hexString.substr(i*2, 2), 16);
        }
        return byteArray;
    },
    
    idPcbItems: [
        {
            name: "__none__",
            w0: "0x0000",
            w1: "0x0000"
        },
        {
            name: "MP48",
            w0: "0x0438",
            w1: "0x023E"
        },
        {
            name: "MP48New",
            w0: "0x04E4",
            w1: "0x01E9"
        },
        {
            name: "MP32 HALF",
            w0: "0x047C",
            w1: "0x0383"
        },
        {
            name: "MP32 FULL",
            w0: "0x047C",
            w1: "0x0282"
        },
        {
            name: "MP32 base",
            w0: "0x047C",
            w1: "0x0181"
        },
        {
            name: "MP32New",
            w0: "0x04D4",
            w1: "0x04DC"
        },
        {
            name: "MP32New_LambdaMod",
            w0: "0x04D4",
            w1: "0x05DD"
        },
        {
            name: "MP32New_VND14",
            w0: "0x0566",
            w1: "0x006B"
        },
        {
            name: "MP48OBD",
            w0: "0x0466",
            w1: "0x016B"
        },
        {
            name: "MP6C",
            w0: "0x04C4",
            w1: "0x01C9"
        },
        {
            name: "MP8C e 2568D",
            w0: "0x04C4",
            w1: "0x02CA"
        }    
    ],

    dirInjClients: [
        { name: "AEB",              value: 0x256B6846, },
        { name: "BIGAS",            value: 0xDBBCB7A6, },
        { name: "ELPIGAZ",          value: 0xF33DC4C2, },
        { name: "EMER",             value: 0xE70791ED, },
        { name: "EMMEGAS",          value: 0xE15B3124, },
        { name: "LANDI",            value: 0x0563DF1E, },
        { name: "MOTGLP",           value: 0x3170E9CA, },
        { name: "NGV",              value: 0x95AA5472, },
        { name: "OMVL",             value: 0xA8AB5AB6, },
        { name: "RODAG",            value: 0xB70797C9, },
        { name: "ROMANO",           value: 0xCB124577, },
        { name: "TARTARINI",        value: 0x296FB361, },
        { name: "TECHNOCARB",       value: 0x47554664, },
        { name: "TOMASETTO",        value: 0xDFCCED23, },
        { name: "ZAVOLI",           value: 0xA165BEC6, },
        { name: "LOVATO",           value: 0x93CD8A18, },
        { name: "ATIKER",           value: 0x81AC2A39, },
        { name: "BLUEFORGREEN",     value: 0x5AFFF8D6, },
        { name: "AS",               value: 0x13FD1A12, },
        { name: "FRONTGAS",         value: 0x81532E31, },
        { name: "ENERGY",           value: 0x19660408, },
        { name: "VOGEL",            value: 0x29322613, },
        { name: "SPRINTGAS",        value: 0x426AEB08, },
        { name: "EUROGAS",          value: 0x66AEB029, },
        { name: "CLIENTE_NEUTRO",   value: 0xffffffff, },
    ],

    getNameFromDirInjClient: (value) => {        
        for (let i = 0; i < utils.dirInjClients.length; i++) {
            const item = utils.dirInjClients[i];
            if (item.value === value) {
                return item.name
            }
        }
        return undefined
    },

    getNameFromIdPcb: (w0, w1) => {        
        for (let i = 0; i < utils.idPcbItems.length; i++) {
            const item = utils.idPcbItems[i];
            if (item.w0 === w0) {
                if (item.w1 === w1) {
                    return item.name
                }
            }
        }
        return undefined
    },

    getIdPcbFromName: (name) => {        
        for (let i = 0; i < utils.idPcbItems.length; i++) {
            const item = utils.idPcbItems[i];
            if (item.name === name) {
                return {
                    w0: item.w0.replace("0x", ""),
                    w1: item.w1.replace("0x", ""),
                }
            }
        }
        return undefined
    },
    
    /**
     * Verifica se l'utente possiede un determinato ruolo.
     *
     * La funzione valuta il campo "role" dell'utente nel seguente modo:
     * - Se l'utente non esiste o il campo "role" è assente, restituisce false.
     * - Il campo "role" può essere una stringa contenente ruoli separati da virgola oppure un array di stringhe.
     * - Per ciascun ruolo, viene eliminato il prefisso "ROLE_" (se presente) per normalizzare i ruoli.
     * - Il parametro targetRole viene anch'esso normalizzato rimuovendo eventuale prefisso "ROLE_".
     * - Se il targetRole è "ADMIN", la funzione ritorna true solo se anche "user.is_admin" è true.
     * - In altri casi, se l'utente è amministratore (user.is_admin === true) e possiede il ruolo "ADMIN",
     *   viene comunque restituito true, indipendentemente dal targetRole richiesto.
     * - Altrimenti, viene verificato se il ruolo normalizzato target è presente nell'array dei ruoli normalizzati dell'utente.
     *
     * @param {Object} user - L'oggetto utente, che deve avere almeno un campo "role" (stringa separata da virgole o array di stringhe)
     *                        e, eventualmente, un campo "is_admin" booleano.
     * @param {string} targetRole - Il ruolo da verificare. Può essere specificato con o senza il prefisso "ROLE_".
     *                              Se il targetRole è "ADMIN", viene considerato valido solo se user.is_admin === true.
     * @returns {boolean} Ritorna true se l'utente possiede il ruolo target (secondo le regole descritte), altrimenti false.
     */
    userHasRole: (user, targetRole) => {
        if (!user || !user.role) return false;
        // Esegui il trim su targetRole
        const trimmedTarget = targetRole.trim();
        // Estrai i ruoli dall'utente: se è stringa, assumiamo che siano separati da ,
        const roles = typeof user.role === 'string'
            ? user.role.split(',').map(role => role.trim())
            : Array.isArray(user.role)
                ? user.role
                : [];
        // Normalizza i ruoli dell'utente eliminando "ROLE_" se presente
        const normalizedRoles = roles.map(r => r.startsWith("ROLE_") ? r.substring(5) : r);
        // Normalizza il target: se inizia con "ROLE_" rimuovilo
        const normalizedTarget = trimmedTarget.startsWith("ROLE_") ? trimmedTarget.substring(5) : trimmedTarget;
        if (normalizedTarget === "ADMIN") return user.is_admin === true;        
        // Se l'utente è amministratore e possiede ADMIN, ritorna true
        if (user.is_admin === true && normalizedRoles.includes("ADMIN")) return true;        
        return normalizedRoles.includes(normalizedTarget);
    },
    userHasRoleAdmin: (user) => { return utils.userHasRole(user, "ADMIN") },
    userHasRoleGuest: (user) => {
        // Se l'utente non esiste o il campo role è vuoto, consideriamo l'utente come guest
        if (!user || !user.role || user.role.trim() === "") return true;
        // Estrai i ruoli dall'utente: se è stringa, assumiamo che siano separati da ,
        const roles = typeof user.role === 'string'
            ? user.role.split(',').map(role => role.trim())
            : Array.isArray(user.role)
                ? user.role
                : [];
        // Normalizza i ruoli dell'utente eliminando "ROLE_" se presente
        const normalizedRoles = roles.map(r => r.startsWith("ROLE_") ? r.substring(5) : r);
        // Normalizza il target: se inizia con "ROLE_" rimuovilo
        const normalizedTarget = "GUEST";
        return normalizedRoles.includes(normalizedTarget);
    },

}

export default utils;
